// extracted by mini-css-extract-plugin
module.exports = {"loading":"faq_loading__Vs2Iz","title-container":"faq_title-container__frXGA","page-title":"faq_page-title__iZ7ln"};